import React from 'react';
import PropTypes from 'prop-types';
import EmailTextController from '../../controllers/EmailTextController';
import { Button, Container, Card, CardContent, CardActions, TextField } from '@material-ui/core';
import { isNullOrUndefined } from '../../helpers/Utils';
import { Alert } from '@material-ui/lab';
import { LoadingOverlay } from '../../components/Common/LoadingOverlay';

export default function EmailTextEditor(props) {
	const [loading, setLoading] = React.useState(false);
	const [warningText, setWarningText] = React.useState(null);
	const [bodyText, setBodyText] = React.useState('');

	React.useEffect(() => {
		async function init() {
			setLoading(true);
			const emailResponse = await EmailTextController.getEmailText();
			if (emailResponse.hasError) {
				HandleError(emailResponse.data);
				setLoading(false);
				return;
			}
			setBodyText(emailResponse.data);
			setLoading(false);
		}
		init();
	}, []);

	function HandleError(response) {
		if (isNullOrUndefined(response)) {
			return 'Failed to connect to server. Please check your internet connection';
		}
		if (isNullOrUndefined(response.response) || isNullOrUndefined(response.response.data)) {
			setWarningText(response.message);
			return;
		}
		setWarningText(response.response.data);
	}

	async function Save() {
		const emailResponse = await EmailTextController.editEmailText(bodyText);
		if (emailResponse.hasError) {
			HandleError(emailResponse.data);
			setLoading(false);
			return;
		}
		props.history.push('/');
	}

	function buildWarning() {
		if (isNullOrUndefined(warningText)) return null;
		return <Alert severity="warning">{warningText}</Alert>;
	}

	return (
		<React.Fragment>
			<LoadingOverlay loading={loading} />
			<Container maxWidth="sm">
				<Card variant="outlined">
					<CardContent>
						<TextField
							label="Email Body Text"
							value={bodyText}
							onChange={e => {
								setBodyText(e.target.value);
							}}
							variant="outlined"
							fullWidth={true}
							multiline
							rowsMax={20}
						/>
					</CardContent>
					<CardActions>
						<Button color="primary" variant="contained" fullWidth onClick={Save}>
							Save
						</Button>
						{buildWarning()}
					</CardActions>
				</Card>
			</Container>
		</React.Fragment>
	);
}

EmailTextEditor.propTypes = {
	history: PropTypes.object,
};
